import React, { useContext, useEffect, useState } from "react";
import Moment from "react-moment";
import {
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import AppContext from "../../Context/AppContext";
import { DataTable } from "../Common/Controls/Controls";
import Busqueda from "./Busqueda/Busqueda";
import { requestAxios, infoSource } from "../../util/util";
import "./Acreditados.css";
const Acreditados = () => {
  const history = useHistory();
  const [showFilter, setShowFilter] = useState(false);
  const [busqueda, setBusqueda] = useState({Estatus:{}});
  const [currentStatus, setCurrentStatus] = useState(0);
  const [datatable, setDatatable] = useState({
    columns: [
      {
        label: "",
        field: "NombreFind",
        width: 0,
      },
      {
        label: "ACREDITADO",
        field: "Nombre",
        width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
        },
      },
      {
        label: "ÚLTIMA FECHA DE PAGO",
        field: "Fecha",
        width: 200,
      },
      {
        label: "TOTAL ADEUDO",
        field: "TotalAdeudo",
        sort: "asc",
        width: 100,
      },
      {
        label: "ESTATUS",
        field: "Estatus",
        sort: "disabled",
        width: 150,
      },
      {
        label: "",
        field: "AcreditadoId",
        sort: "disabled",
        width: 100,
      },
    ],
    initialState: {
      pageIndex: 0,
      hiddenColumns: ["NombreFind"], //use property option, in columns define id name "id"
    },
    rows: [],
  });
  const { checkUserSession } = useContext(AppContext);

  useEffect(() => {
    loadInfo();
  }, []);
  async function loadInfo() {
    const infoUs = checkUserSession();
    const data = await infoSource.Acreditados.getRegistrosAcreditado(infoUs);
    const dataInfo = {
      ...datatable,
      rows: data.map((item, i) => ({
        NombreFind: `${item.AcreditadoId} ${item.Nombre} ${item.Correo}`,
        Nombre: (
          <div className="DataTableName__container">
            <div className="DataTableNameId__container">
              {item.AcreditadoId}
            </div>
            <div className="DataTableNameNames__container">
              <h1>{item.Nombre}</h1>
              <h4>{item.Correo}</h4>
            </div>
          </div>
        ),
        Fecha: (
          <div className="acreditadoUltimoPago">
              {item.UltimoPago != null ? 
              <Moment
              locale="es"
              format="DD-MMM-YYYY"
              date={item.UltimoPago}
            /> : "No Hay pagos"}
          </div>         
        ),
        TotalAdeudo: (
          <div className="acreditadoUltimoPago">
            $ {formatNumber(Number(item.TotalAdeudo))}
          </div>
        ),
        Estatus: (
          <div
            className={`itemStatusAcreditados itemStatusAcreditados${item.EstatusId}`}
          >
            {item.Estatus}
          </div>
        ),
        TipoGestion: item.tipoGestion,
        AcreditadoId: (
          <button
            className="btnDetalleExpediente"
            onClick={() =>
              history.push(`./AcreditadosDetalle/${item.AcreditadoId}`)
            }
          >
            Detalles
          </button>
        ),
      })),
    };
    setDatatable(dataInfo);
  }

  async function loadInfoBusqueda(nombre) {
    const infoUs = checkUserSession();
    const postObj = { ...busqueda, Nombre: nombre,Convenio:busqueda.Estatus.Convenio,Demanda:busqueda.Estatus.Demanda};
    const data = await infoSource.Acreditados.getRegistrosAcreditadoBusqueda(
      infoUs,
      postObj
    );
    const dataInfo = {
      ...datatable,
      rows: data.map((item, i) => ({
        NombreFind: `${item.AcreditadoId} ${item.Nombre} ${item.Correo}`,
        Nombre: (
          <div className="DataTableName__container">
            <div className="DataTableNameId__container">
              {item.AcreditadoId}
            </div>
            <div className="DataTableNameNames__container">
              <h1>{item.Nombre}</h1>
              <h4>{item.Correo}</h4>
            </div>
          </div>
        ),
        Fecha: (
          <div className="acreditadoUltimoPago">
              {item.UltimoPago != null ? 
              <Moment
              locale="es"
              format="DD-MMM-YYYY"
              date={item.UltimoPago}
            /> : "No Hay pagos"}
          </div>   
        ),
        TotalAdeudo: (
          <div className="acreditadoUltimoPago">
            $ {formatNumber(Number(item.TotalAdeudo))}
          </div>
        ),
        Estatus: (
          <div
            className={`itemStatusAcreditados itemStatusAcreditados${item.EstatusId}`}
          >
            {item.Estatus}
          </div>
        ),
        TipoGestion: item.tipoGestion,
        AcreditadoId: (
          <button
            className="btnDetalleExpediente"
            onClick={() =>
              history.push(`./AcreditadosDetalle/${item.AcreditadoId}`)
            }
          >
            Detalles
          </button>
        ),
      })),
    };
    setDatatable(dataInfo);
  }

  function getStringToDate(datestr) {
    const newDate = new Date(datestr);
    return newDate;
  }
  function formatNumber(num) {
    const options2 = { style: "currency", currency: "USD" };
    const numberFormat2 = new Intl.NumberFormat("en-US", options2);
    return numberFormat2.format(num).replace("$", "");
  }
  function setValueBusqueda(field, value) {
    let newObj = { ...busqueda };
    newObj[field] = value;
    setBusqueda(newObj);
  }
  const estatusAcreditado = [
    { Convenio: 0, Demanda: 0 },
    { Convenio: 1, Demanda: 0 },
    { Convenio: 0, Demanda: 1 },
    { Convenio: 1, Demanda: 1 },
  ];
  return (
    <div className="Acreditados__container">
      <Busqueda
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        buscar={loadInfoBusqueda}
      />
      {showFilter && (
        <div className="AcreditadosFilter__container">
          <div className="AcreditadosFilterItem__container">
            <TextField
              id="outlined-basic"
              label="Escuela"
              variant="outlined"
              value={busqueda["Escuela"]}
              onChange={(input) => {
                setValueBusqueda("Escuela", input.target.value);
              }}
              fullWidth
            />
            <TextField
              id="outlined-basic"
              label="Carrera"
              variant="outlined"
              value={busqueda["Carrera"]}
              onChange={(input) => {
                setValueBusqueda("Convenio", input.target.value.convenio);
                setValueBusqueda("Demanda", input.target.value.demanda);
              }}
              fullWidth
            />
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Estatus Acreditado
              </InputLabel>
              <Select
                className="cmbTipoGestion"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Estatus Acreditado"
                onChange={(input) => {
                  setCurrentStatus(input.target.value);
                  setValueBusqueda(
                    "Estatus",
                    estatusAcreditado[input.target.value]
                  );
                }}
                value={currentStatus}
              >
                <MenuItem className="cmbTipoGestion_Item" value={0}>
                  Sin Demanda, Ni Convenio
                </MenuItem>
                <MenuItem className="cmbTipoGestion_Item" value={1}>
                  Sin Demanda, Con Convenio
                </MenuItem>
                <MenuItem className="cmbTipoGestion_Item" value={2}>
                  Con Demanda, sin Convenio
                </MenuItem>
                <MenuItem className="cmbTipoGestion_Item" value={3}>
                  Con Demanda, Con Convenio
                </MenuItem>
              </Select>
            </FormControl>
          </div>
          <br />
          <h3>Monto de adeudo Total</h3>
          <div className="AcreditadosFilterItem__container">
            <TextField
              id="outlined-basic"
              type="number" //ad this line
              label="Desde"
              variant="outlined"
              value={busqueda["Desde"]}
              onChange={(input) => {
                setValueBusqueda("Desde", input.target.value);
              }}
              fullWidth
            />
            <TextField
              id="outlined-basic"
              type="number" //ad this line
              label="Hasta"
              variant="outlined"
              value={busqueda["Hasta"]}
              onChange={(input) => {
                setValueBusqueda("Hasta", input.target.value);
              }}
              fullWidth
            />
            <TextField
              id="outlined-basic"
              label="Ciudad"
              variant="outlined"
              value={busqueda["Ciudad"]}
              onChange={(input) => {
                setValueBusqueda("Ciudad", input.target.value);
              }}
              fullWidth
            />
          </div>
          <br />
        </div>
      )}
      <div className="TituloTablaAcreditado">
        {datatable.rows.length} Acreditados <span>Total del listado</span>
      </div>
      <DataTable hover data={datatable} className="mdbDataTableAcreditados" />
    </div>
  );
};

export default Acreditados;
